import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import PortManager from '../../components/account/PortManager';

const PortManage = ({ account, dispatch, intl }) => {
  return <PortManager {...account} intl={intl} dispatch={dispatch} />;
};

const mapStateToProps = state => {
  return Object.assign({}, state, { loading: state.loading.global });
};

export default connect(mapStateToProps)(injectIntl(PortManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/PortManage.js